import { HOST } from '../config';
import { apiGet, apiPost } from '../api';
import axios from 'axios';

export const A = {
  REQUEST_UPLOAD_FILE: 'REQUEST_UPLOAD_FILE',
  RECEIVE_UPLOAD_FILE: 'RECEIVE_UPLOAD_FILE',
  ERROR_UPLOAD_FILE: 'ERROR_UPLOAD_FILE',

  REQUEST_UPDATE_IMPORT_TASK: 'REQUEST_UPDATE_IMPORT_TASK',
  RECEIVE_UPDATE_IMPORT_TASK: 'RECEIVE_UPDATE_IMPORT_TASK',
  ERROR_UPDATE_IMPORT_TASK: 'ERROR_UPDATE_IMPORT_TASK',

  REQUEST_START_TASK_PROCESS: 'REQUEST_START_TASK_PROCESS',
  RECEIVE_START_TASK_PROCESS: 'RECEIVE_START_TASK_PROCESS',
  ERROR_START_TASK_PROCESS: 'ERROR_START_TASK_PROCESS',

  REQUEST_GET_IMPORT_TASKS: 'REQUEST_GET_IMPORT_TASKS',
  RECEIVE_GET_IMPORT_TASKS: 'RECEIVE_GET_IMPORT_TASKS',
  ERROR_GET_IMPORT_TASKS: 'ERROR_GET_IMPORT_TASKS',

  REQUEST_GET_IMPORT_TASK_BY_ID: 'REQUEST_GET_IMPORT_TASK_BY_ID',
  RECEIVE_GET_IMPORT_TASK_BY_ID: 'RECEIVE_GET_IMPORT_TASK_BY_ID',
  ERROR_GET_IMPORT_TASK_BY_ID: 'ERROR_GET_IMPORT_TASK_BY_ID',

  REQUEST_GET_FIELD_LIST: 'REQUEST_GET_FIELD_LIST',
  RECEIVE_GET_FIELD_LIST: 'RECEIVE_GET_FIELD_LIST',
  ERROR_GET_FIELD_LIST: 'ERROR_GET_FIELD_LIST',

  REQUEST_IMPORT_PARSED_PRODUCTS: 'REQUEST_IMPORT_PARSED_PRODUCTS',
  RECEIVE_IMPORT_PARSED_PRODUCTS: 'RECEIVE_IMPORT_PARSED_PRODUCTS',
  ERROR_IMPORT_PARSED_PRODUCTS: 'ERROR_IMPORT_PARSED_PRODUCTS',

  REQUEST_GET_SKU_IMPORT_TEMPLATE: 'REQUEST_GET_SKU_IMPORT_TEMPLATE',
  RECEIVE_GET_SKU_IMPORT_TEMPLATE: 'RECEIVE_GET_SKU_IMPORT_TEMPLATE',
  ERROR_GET_SKU_IMPORT_TEMPLATE: 'ERROR_GET_SKU_IMPORT_TEMPLATE',
};

export const fetchUploadFile = (formData) => {
  return (dispatch, getState) => {
    dispatch(requestUploadFile());
    return new Promise((resolve, reject) => {
      apiPost({
        url: HOST + '/api/lite/import/upload',
        tokens: getState().auth.tokenData,
        formData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveUploadFile(res));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorUploadFile(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorUploadFile(err));
          reject(err);
        },
      });
    });
  };
};

const requestUploadFile = () => {
  return {
    type: A.REQUEST_UPLOAD_FILE,
  };
};

const receiveUploadFile = (data) => {
  return {
    type: A.RECEIVE_UPLOAD_FILE,
    data,
  };
};

const errorUploadFile = (err) => {
  return {
    type: A.ERROR_UPLOAD_FILE,
    err,
  };
};

export const fetchUpdateImportTask = (data) => {
  return (dispatch, getState) => {
    dispatch(requestUpdateImportTask());
    return new Promise((resolve, reject) => {
      apiPost({
        url: HOST + '/api/lite/import/task',
        tokens: getState().auth.tokenData,
        body: data,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveUpdateImportTask(res));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorUpdateImportTask(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorUpdateImportTask(err));
          reject(err);
        },
      });
    });
  };
};

const requestUpdateImportTask = () => {
  return {
    type: A.REQUEST_UPDATE_IMPORT_TASK,
  };
};

const receiveUpdateImportTask = (data) => {
  return {
    type: A.RECEIVE_UPDATE_IMPORT_TASK,
    data,
  };
};

const errorUpdateImportTask = (err) => {
  return {
    type: A.ERROR_UPDATE_IMPORT_TASK,
    err,
  };
};

export const fetchStartTaskProcess = (fileId) => {
  return (dispatch, getState) => {
    dispatch(requestStartTaskProcess());
    return new Promise((resolve, reject) => {
      apiPost({
        url: HOST + '/api/lite/import/process?id=' + fileId,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveStartTaskProcess(res));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorStartTaskProcess(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorStartTaskProcess(err));
          reject(err);
        },
      });
    });
  };
};

const requestStartTaskProcess = () => {
  return {
    type: A.REQUEST_START_TASK_PROCESS,
  };
};

const receiveStartTaskProcess = (data) => {
  return {
    type: A.RECEIVE_START_TASK_PROCESS,
    data,
  };
};

const errorStartTaskProcess = (err) => {
  return {
    type: A.ERROR_START_TASK_PROCESS,
    err,
  };
};

export const fetchGetImportTasks = ({ size, page, templateType }) => {
  let url = HOST + `/api/lite/import/task?size=${size}`;
  if (page) url += `&page=${page}`;
  if (templateType) url += `&templateType=${templateType}`;

  return (dispatch, getState) => {
    dispatch(requestGetImportTasks());
    return new Promise((resolve, reject) => {
      apiGet({
        url,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res) {
            dispatch(receiveGetImportTasks(res));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetImportTasks(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetImportTasks(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetImportTasks = () => {
  return {
    type: A.REQUEST_GET_IMPORT_TASKS,
  };
};

const receiveGetImportTasks = (data) => {
  return {
    type: A.RECEIVE_GET_IMPORT_TASKS,
    data,
  };
};

const errorGetImportTasks = (err) => {
  return {
    type: A.ERROR_GET_IMPORT_TASKS,
    err,
  };
};

export const fetchGetImportTaskById = (taskId) => {
  let url = HOST + '/api/lite/import/task';
  if (taskId) url += '?id=' + taskId;
  return (dispatch, getState) => {
    dispatch(requestGetImportTaskById());
    return new Promise((resolve, reject) => {
      apiGet({
        url,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveGetImportTaskById(res));
            resolve(res);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetImportTaskById(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetImportTaskById(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetImportTaskById = () => {
  return {
    type: A.REQUEST_GET_IMPORT_TASK_BY_ID,
  };
};

const receiveGetImportTaskById = (data) => {
  return {
    type: A.RECEIVE_GET_IMPORT_TASK_BY_ID,
    data,
  };
};

const errorGetImportTaskById = (err) => {
  return {
    type: A.ERROR_GET_IMPORT_TASK_BY_ID,
    err,
  };
};

export const fetchGetFieldList = (templateType) => {
  const url =
    templateType === 'SKU' ? '/api/lite/import/field_list' : '/api/lite/import/order_field_list';
  return (dispatch, getState) => {
    dispatch(requestGetFieldList());
    return new Promise((resolve, reject) => {
      apiGet({
        url: HOST + url,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res) {
            dispatch(receiveGetFieldList(res.fields));
            resolve(res.fields);
          } else {
            const err = { data: { errors: res.errors } };
            dispatch(errorGetFieldList(err));
            reject(err);
          }
        },
        error: (err) => {
          dispatch(errorGetFieldList(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetFieldList = () => {
  return {
    type: A.REQUEST_GET_FIELD_LIST,
  };
};

const receiveGetFieldList = (data) => {
  return {
    type: A.RECEIVE_GET_FIELD_LIST,
    data,
  };
};

const errorGetFieldList = (err) => {
  return {
    type: A.ERROR_GET_FIELD_LIST,
    err,
  };
};

export const fetchImportParsedProducts = (file, searchColumn, query) => {
  const formData = new FormData();
  formData.append('upfile', file);
  if (searchColumn) formData.append('searchColumn', searchColumn);
  if (!query) query = '';

  return (dispatch, getState) => {
    dispatch(requestImportParsedProducts());
    return new Promise((resolve, reject) => {
      apiPost({
        url: HOST + `/api/lite/products/templates/items${query}`,
        formData,
        tokens: getState().auth.tokenData,
        callback: (res) => {
          if (res.success) {
            dispatch(receiveImportParsedProducts(res));
            resolve(res);
          } else {
            if (!res.items || !res.items.length) {
              const err = { data: { errors: res.errors } };
              dispatch(errorImportParsedProducts(err));
              reject(err);
            } else {
              dispatch(receiveImportParsedProducts(res));
              resolve(res);
            }
          }
        },
        error: (err) => {
          dispatch(errorImportParsedProducts(err));
          reject(err);
        },
      });
    });
  };
};

const requestImportParsedProducts = () => {
  return {
    type: A.REQUEST_IMPORT_PARSED_PRODUCTS,
  };
};

const receiveImportParsedProducts = (data) => {
  return {
    type: A.RECEIVE_IMPORT_PARSED_PRODUCTS,
    data,
  };
};

const errorImportParsedProducts = (err) => {
  return {
    type: A.ERROR_IMPORT_PARSED_PRODUCTS,
    err,
  };
};

export const fetchItemsTemplate = (query) => (dispatch, getState) => {
  if (!query) query = '';
  return axios.get(`${HOST}/api/lite/products/templates/items${query}`, {
    headers: {
      Authorization: 'Bearer ' + getState().auth.tokenData.access_token,
    },
    responseType: 'blob',
  });
};

export const fetchGetSkuImportTemplate = (type) => {
  return (dispatch, getState) => {
    dispatch(requestGetSkuImportTemplate());
    return new Promise((resolve, reject) => {
      apiGet({
        url: HOST + `/api/lite/import/templates/${type}`,
        tokens: getState().auth.tokenData,
        responseType: 'blob',
        withoutCommonHeaders: true,
        callback: (blob) => {
          if (blob) {
            dispatch(receiveGetSkuImportTemplate());
            resolve(blob);
          }
        },
        error: (err) => {
          dispatch(errorGetSkuImportTemplate(err));
          reject(err);
        },
      });
    });
  };
};

const requestGetSkuImportTemplate = () => {
  return {
    type: A.REQUEST_GET_SKU_IMPORT_TEMPLATE,
  };
};

const receiveGetSkuImportTemplate = (data) => {
  return {
    type: A.RECEIVE_GET_SKU_IMPORT_TEMPLATE,
    data,
  };
};

const errorGetSkuImportTemplate = (err) => {
  return {
    type: A.ERROR_GET_SKU_IMPORT_TEMPLATE,
    err,
  };
};

export const fetchGetLoadChestnyznakExcel = (query) => (dispatch, getState) => {
  if (!query) query = '';
  return axios.get(`${HOST}/api/lite/products/load/unique_number/template/excel`, {
    headers: {
      Authorization: 'Bearer ' + getState().auth.tokenData.access_token,
    },
    responseType: 'blob',
  });
};
